module.exports = __webpack_public_path__ + "static/img/Thongkee_Logo.56cd043.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Thongkee_Logo.png
// module id = xZbb
// module chunks = 0